import React from "react"
import { withRouter, Switch } from "react-router-dom"
import LoadableComponent from "../utils/LoadableComponent"
import PrivateRoute from "../components/PrivateRoute/privateRoute"

const AdminHome = LoadableComponent(() => import("../pages/admin/home/index"));
const AdminStudent = LoadableComponent(() => import("../pages/admin/student/index"));
const AdminTeacher = LoadableComponent(() => import("../pages/admin/teacher/index"));
const AdminCourse = LoadableComponent(() => import("../pages/admin/course/index"));
const AdminField = LoadableComponent(() => import("../pages/admin/field/index"));
const AdminShow = LoadableComponent(() => import("../pages/admin/show/index"));
const AdminBanner = LoadableComponent(() => import("../pages/admin/banner/index"));
const AdminSetting = LoadableComponent(() => import("../pages/admin/setting/index"));
const Print = LoadableComponent(() => import("../pages/admin/print/index"));
const Report = LoadableComponent(() => import("../pages/admin/report/index"));

class Routes extends React.Component {
    render() {
        return (
            <Switch>
                <PrivateRoute exact path="/sys/home" component={AdminHome} />
                <PrivateRoute exact path="/sys/student" component={AdminStudent} />
                <PrivateRoute exact path="/sys/teacher" component={AdminTeacher} />
                <PrivateRoute exact path="/sys/course" component={AdminCourse} />
                <PrivateRoute exact path="/sys/field" component={AdminField} />
                <PrivateRoute exact path="/sys/show" component={AdminShow} />
                <PrivateRoute exact path="/sys/banner" component={AdminBanner} />
                <PrivateRoute exact path="/sys/setting" component={AdminSetting} />
                <PrivateRoute exact path="/sys/print" component={Print} />
                <PrivateRoute exact path="/sys/report" component={Report} />
            </Switch>
        )
    }
}

export default Routes;